import axios from 'axios'
import '../Config'

const jwtToken = localStorage.getItem("authorization");

const INSTRUCTOR = 'v1'
const COURSE_API_URL = global.config.backend
const INSTRUCTOR_API_URL = `${COURSE_API_URL}/${INSTRUCTOR}`

class CarrinhoService {

    create() {
        return axios.get(`${INSTRUCTOR_API_URL}/carrinho/create`, {headers: {'authorization': "Bearer " + jwtToken}});
    }

    addItem(item) {
        return axios.post(`${INSTRUCTOR_API_URL}/carrinho/additem`, item, {headers: {'authorization': "Bearer " + jwtToken}});
    }

    removeItem(item) {
        return axios.post(`${INSTRUCTOR_API_URL}/carrinho/removeitem`, item, {headers: {'authorization': "Bearer " + jwtToken}});
    }

    save(carrinho) {
        return axios.post(`${INSTRUCTOR_API_URL}/carrinho/save`, carrinho, {headers: {'authorization': "Bearer " + jwtToken}});
    }

}

export default new CarrinhoService()